exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-types__add-button {\n  margin-bottom: 16px;\n  float: right;\n}\n.member-types__member-type-color {\n  height: 32px;\n}\n.member-types__table {\n  clear: both;\n}\n.manage-member-form__current-member-type-table {\n  margin-bottom: 16px;\n  clear: both;\n}\n.manage-member-form__history-button {\n  margin-bottom: 16px;\n  float: right;\n}\n.manage-member-form__remaining-days {\n  display: inline-block;\n}\n.table__operation {\n  margin-left: 8px;\n}\n", ""]);

// exports
